import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "op-screen mx-auto flex max-w-3xl flex-col items-center px-6 py-20 text-center" };
const _hoisted_2 = { class: "flex flex-col items-center gap-2" };
const _hoisted_3 = { class: "text-xl font-bold leading-6 text-(--colors-text-black-default)" };
const _hoisted_4 = { class: "text-sm leading-5 text-(--colors-text-body-subtle)" };
import { useRouter } from "vue-router";
import { Button } from "@eudonet/opal";
/**
 * Generic confirmation screen for the communication-preferences flows
 * (US-5.19). Rendered as a dedicated route after a successful save
 * (`updated`) or a global opt-out (`unsubscribedAll`); the back button
 * returns to the preferences form, which the recipient can use to change
 * their mind. The token stays valid (it is not single-use), so the round
 * trip works without re-issuing a link.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'EmailPreferencesResultView',
    props: {
        token: {},
        variant: {}
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        function goToPreferences() {
            router.push({ name: "EmailPreferences", params: { token: props.token } });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "relative mb-8 flex h-[72px] w-[72px] items-center justify-center" }, [
                    _createElementVNode("span", {
                        class: "absolute inset-0 rounded-full bg-(--colors-text-success) opacity-20 blur-2xl",
                        "aria-hidden": "true"
                    }),
                    _createElementVNode("i", {
                        class: "ri-check-line relative text-[54px] leading-none text-(--colors-text-success)",
                        "aria-hidden": "true"
                    })
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(`emailPreferences.result.${__props.variant}.title`)), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(`emailPreferences.result.${__props.variant}.subtitle`)), 1 /* TEXT */)
                ]),
                _createVNode(_unref(Button), {
                    class: "mt-6",
                    variant: "primary",
                    "icon-left": "ri-arrow-left-line",
                    label: _ctx.$t('emailPreferences.result.back'),
                    onClick: goToPreferences
                }, null, 8 /* PROPS */, ["label"])
            ]));
        };
    }
});
